module.exports = __webpack_public_path__ + "img/KinokoTable11.1e23c0d7.jpg";